import * as React from 'react'

// import ButtonBase from '@material-ui/core/ButtonBase'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { Divider, Typography as Text } from '@material-ui/core'

import { useDispatch, useSelector } from 'react-redux'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import Widget from '../Widget'
import myExpensesStyle from './myExpensesStyle'
import {
  fetchMyExpenses,
  selectMyExpensesData,
  selectMyExpensesStatus,
} from './myExpensesSlice'
import Loading from '../helpers/Loading'
import IconPicker from '../../../apps/AppComponents/IconPicker/IconPicker'
import { ErrorMessage } from '../../DashboardComponents/ErrorMessages/ErrorMsg'

function MyExpenses({
  className,
  title,
  widgetId,
  showNote,
  noteMessage,
  notePosition,
  noteBackground,
  noteIcon,
  noteUrl,
  noteFontColor,
}) {
  const dispatch = useDispatch()
  const widgetData = useSelector(selectMyExpensesData)
  const widgetCallState = useSelector(selectMyExpensesStatus)
  const classes = myExpensesStyle()

  React.useEffect(() => {
    dispatch(fetchMyExpenses())
  }, [])

  return (
    <Widget className={className}>
      <Widget.Header title={title} category="Finance" />
      <Widget.Content
        className={classes.container}
        showNote={showNote}
        noteMessage={noteMessage}
        notePosition={notePosition}
        noteBackground={noteBackground}
        noteIcon={noteIcon}
        noteUrl={noteUrl}
        noteFontColor={noteFontColor}
        addFooterStroke
        widgetId={widgetId}
      >
        {renderMyExpensesState(widgetCallState, widgetData, classes)}
      </Widget.Content>
    </Widget>
  )
}

function renderMyExpensesState(widgetCallState, widgetData, classes) {
  switch (widgetCallState) {
    case 'fulfilled':
      return <Loaded widgetData={widgetData} classes={classes} />
    case 'pending':
      return <Loading />
    case 'error':
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <ErrorMessage />
        </Grid>
      )
    default:
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item></Grid>
        </Grid>
      )
  }
}

function Loaded({ widgetData, classes }) {
  return (
    <>
      <Grid container className={classes.expenseListRecordsContainer}>
        {widgetData?.expenseList && widgetData.expenseList?.length > 0 ? (
          widgetData.expenseList.map((expense) => (
            <Grid item xs={12}>
              <ExpenseObject
                key={`${expense.amount} ${expense.label}`}
                expense={expense}
              />
            </Grid>
          ))
        ) : (
          <Box
            display="flex"
            alignItems="center"
            marginLeft="auto"
            marginRight="auto"
            flexDirection="column"
            className={classes.noExpenseData}
          >
            <IconPicker iconName="check-circle" color="#00b339" size="5x" />
            <Typography variant="subtitle1">No Expense Data</Typography>
          </Box>
        )}
      </Grid>
    </>
  )
}

function ExpenseObject({ expense }) {
  const classes = myExpensesStyle()
  return (
    <Card className={classes.expenseObject} variant="outlined" tabIndex={0}>
      {/* removed as items are not clickable */}
      {/* <ButtonBase className={classes.expenseObjectLink}> */}
      <CardContent className={classes.expenseObjectBackground}>
        <Grid container direction="column" spacing={1}>
          <Grid container direction="row" justifyContent="space-between">
            <Grid item>
              <Text variant="h4">${expense.amount}</Text>
            </Grid>

            <Grid item>
              {expense.paid ? (
                <div>
                  <Grid item>
                    <Grid container alignItems="center">
                      <CheckCircleIcon className={classes.checkCircleIcon} />

                      <Text variant="subtitle1" className={classes.paidColor}>
                        PAID
                      </Text>
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <div>
                  <Grid item>
                    <Grid container alignItems="center">
                      <RemoveCircleIcon className={classes.removeCircleIcon} />

                      <Text variant="subtitle1" className={classes.unpaidColor}>
                        UNPAID
                      </Text>
                    </Grid>
                  </Grid>
                </div>
              )}
            </Grid>
          </Grid>
          <Grid item>
            <Divider />
          </Grid>
          <Grid container justifyContent="flex-start">
            <Text variant="body1">{expense.label}</Text>
          </Grid>
        </Grid>
      </CardContent>
      {/* </ButtonBase> */}
    </Card>
  )
}

export default MyExpenses
